import { Backend } from '@/services/Backend'

export interface AppConfig {
    passwordStrengthMinScore: number
}

export class ConfigService extends Backend {
    protected baseUrl = ''

    fetchConfig(): Promise<AppConfig> {
        return this.get('/api/config')
    }
}
